module["exports"] = [
  "cz",
  "com",
  "net",
  "eu",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/internet/domain_suffix.js
// module id = 224
// module chunks = 0